import React, { Component} from 'react';
import {refreshToken} from '../api.js';
import ReactDOM from 'react-dom';
import {urls} from '../config.js';

export default function PostFileDownloadElectricCSV({ labels, values, contentRender }) {

  const downloadCSV = () => {
    if (!values?.length) {
      alert("No hay datos para descargar");
      return;
    }

    const headers = [
      "CLAVE DX",
      "FECHA HORA",
      "CONSUMO KWH",
      "CONSUMO KVARH",
      "VERSIÓN",
      "HORARIO",
      "RUT DISTRIBUIDORA",
      "NOMBRE DISTRIBUIDORA",
      "CÓDIGO SAP INSTALACIÓN",
      "CÓDIGO SAP CLIENTE",
      "CÓDIGO SAP CUENTA CONTRATO",
      "RUT CLIENTE",
      "NUEVO CLIENTE DX",
      "RAZÓN SOCIAL CLIENTE"
    ];

    const escapeValue = (val) => {
      if (val === null || val === undefined) return "";

      const str = String(val);

      // Si contiene coma, comillas o salto de línea → ENCERRAR ENTRE ""
      if (/[",\n]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
      }

      // Si no tiene caracteres problemáticos → devolver normal
      return str;
    };

    let csv = headers.join(",") + "\n";

    for (let i = 0; i < values.length; i++) {
      const item = values[i]; // acceso correcto
      const dist = item.distribuidor || {};

      const row = [
        item.clave_dx,
        item.fecha_hora,
        item.consumo_kwh,
        item.consumo_kvarh,
        item.version,
        item.horario,
        dist.rut_distribuidora,
        dist.nombre_distribuidora,
        dist.codigo_sap_instalacion,
        dist.codigo_sap_cliente,
        dist.codigo_sap_cuenta_contrato,
        dist.rut_cliente,
        dist.nuevo_cliente_dx,
        dist.razon_social_cliente
      ];

      // Escapar valores
      const escapedRow = row.map(escapeValue);

      csv += escapedRow.join(",") + "\n";
    }

    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "consumo.csv");
    document.body.appendChild(link);
    link.click();

    link.remove();
    URL.revokeObjectURL(url);
  };


  return (
    <div onClick={downloadCSV}>
      {contentRender()}
    </div>
  );
}